import React from 'react';
import { ModalContent, ModalHeader, Typography } from 'common/components';

export const Showrooms = () => (
  <>
    <ModalHeader title="Посмотреть вживую можно в&nbsp;магазинах" />
    <ModalContent variant="simple">
      <Typography adaptive={false} variant="m" size="body_long">
        Приезжайте в&nbsp;гости в&nbsp;любой удобный магазин&nbsp;&mdash; вы&nbsp;сможете увидеть примеры
        ванных комнат, оценить качество товара и&nbsp;стиль, а&nbsp;наши специалисты с&nbsp;радостью
        помогут реализовать любую задумку, подберут необходимую технику и&nbsp;оформят услуги.
      </Typography>
    </ModalContent>
  </>
);
